var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.txt)?_c('v-btn',{staticClass:"GridButton",attrs:{"text":"","color":"black"},on:{"click":_vm.clicked}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.txt)}}),_vm._v("  "),_c('v-icon',{attrs:{"small":""}},[_vm._v("arrow_right")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }